// extracted by mini-css-extract-plugin
export var horizontalScroll = "styles-module--horizontal-scroll--1b131";
export var horizontalScroll__content = "styles-module--horizontal-scroll__content--e8915";
export var horizontalScroll__slide = "styles-module--horizontal-scroll__slide--35cab";